// Lightweight Meta Pixel helper.
// Safely fires pixel events when fbq is available on the page.

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
  }
}

export function trackPixel(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return

  if (typeof window.fbq === 'function') {
    window.fbq('track', event, params)
  } else {
    // Pixel not loaded (e.g. in preview) — log for visibility.
    // eslint-disable-next-line no-console
    console.info('[pixel]', event, params)
  }
}
